import classNames from 'classnames/bind'
import { useState, useMemo, useEffect } from 'react'

import { QRIcon, UserIcon, XMarkIcon } from '~/components/Icons' //ChevronDownIcon, 
import styles from './ModalForm.module.scss'
import images from '~/assets/images'
import Button from '~/components/Button'
import { Link } from 'react-router-dom'

const cx = classNames.bind(styles)

function ModalForm({ onHide }) {
    const [formLoginState, setFormLoginState] = useState('login')
    const [filteredForm, setFilteredForm] = useState([])

    const loginRegisterForm = useMemo(() => [
        {
            type: 'login',
            title: '登录 4K视频站',
            contents: [
                {
                    icon: <QRIcon />,
                    title: '使用二维码登录',
                },
                {
                    icon: <UserIcon />,
                    title: '手机号 / 邮箱 / 账号 ID',
                },
                {
                    icon: <img src={images.facebook} alt="" />,
                    title: '使用 Facebook 登录',
                },
                {
                    icon: <img src={images.google} alt="" />,
                    title: '使用 Google 登录',
                },
                {
                    icon: <img src={images.twitter} alt="" />,
                    title: '使用 Twitter 登录',
                },
                {
                    icon: <img src={images.line} alt="" />,
                    title: '使用 LINE 登录',
                },
                {
                    icon: <img src={images.kakaotalk} alt="" />,
                    title: '使用 KakaoTalk 登录',
                },
                {
                    icon: <img src={images.apple} alt="" />,
                    title: '使用 Apple 登录',
                },
                {
                    icon: <img src={images.instagram} alt="" />,
                    title: '使用 Instagram 登录',
                },
            ]
        },
        {
            type: 'register',
            title: '注册 4K视频站',
            showMore: true,
            contents: [
                {
                    icon: <UserIcon />,
                    title: '使用手机号或邮箱',
                },
                {
                    icon: <img src={images.facebook} alt="" />,
                    title: '使用 Facebook 登录',
                },
                {
                    icon: <img src={images.google} alt="" />,
                    title: '使用 Google 登录',
                },
                {
                    icon: <img src={images.line} alt="" />,
                    title: '使用 LINE 登录',
                },
                {
                    icon: <img src={images.kakaotalk} alt="" />,
                    title: '使用 KakaoTalk 登录',
                },
            ]
        },
        {
            type: 'register-expanded',
            title: '注册 4K视频站',
            contents: [
                {
                    icon: <UserIcon />,
                    title: '使用手机号或邮箱',
                },
                {
                    icon: <img src={images.facebook} alt="" />,
                    title: '使用 Facebook 登录',
                },
                {
                    icon: <img src={images.google} alt="" />,
                    title: '使用 Google 登录',
                },
                {
                    icon: <img src={images.line} alt="" />,
                    title: '使用 LINE 登录',
                },
                {
                    icon: <img src={images.kakaotalk} alt="" />,
                    title: '使用 KakaoTalk 登录',
                },
            ]
        }
    ], [])

    useEffect(() => {
        const newForm = loginRegisterForm.find(form => form.type === formLoginState)
        setFilteredForm(newForm)
    }, [loginRegisterForm, formLoginState])

    return (
        <div className={cx('modal-mask')}>
            <div className={cx('wrapper')}>
                <div className={cx('container')}>

                    <div className={cx('inner')}>
                        <div className={cx('title')}>{filteredForm.title}</div>

                        <div className={cx('list')}>
                            {filteredForm.contents?.map((content, index) => {
                                return <Button className={cx('btn')} style={{ height: '44px', marginBottom: '16px' }} key={index} onClick={content.onClick}>
                                    <span className={cx('icon')}>{content.icon}</span> <span>{content.title}</span>
                                </Button>
                            })}

                            {/* {filteredForm.showMore && <div className={cx('more-btn')} onClick={() => setFormLoginState('register-expanded')}><ChevronDownIcon /></div>} */}
                        </div>
                    </div>

                    {formLoginState.startsWith('register') &&
                        <div className={cx('agreement')}>
                            <p> 继续即表示你同意<Link to="/">使用条款</Link>,并确认已阅读我们的<Link to="/">隐私政策</Link>。</p>
                        </div>}

                    <div className={cx('footer')}>
                        {formLoginState === 'login' ?
                            <>还没有账号? <p style={{ color: 'red' }} onClick={() => setFormLoginState('register')}> 注册</p> </> :
                            <>已有账号? <p style={{ color: 'red' }} onClick={() => setFormLoginState('login')}>登录</p></>
                        }
                    </div>
                </div>

                <div className={cx('close-btn')} onClick={onHide}> <XMarkIcon /> </div>
            </div>
        </div>

    )
}

export default ModalForm